import { MUSTNeverHappenException, tsValidateArray, tsValidateIsInRange, tsValidateResult, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { OrderAvailability_Always, OrderAvailability_Partial } from './consts.js';
import { DBDef_EHRInstallation } from '../ehr-installation/db-def.js';
const Validator_GeneratedProps = {};
const Validator_OrderConfigAvailability_Partial_Data = {
    start: tsValidateIsInRange([[0, 1440]]), //A number between 0 and 24*60, the total minutes in a day.
    end: tsValidateIsInRange([[0, 1440]]),
};
const Validator_OrderConfigAvailability_Always = {
    type: tsValidateValue([OrderAvailability_Always]),
};
const Validator_OrderConfigAvailability_Partial = {
    type: tsValidateValue([OrderAvailability_Partial]),
    data: {
        sun: tsValidateArray(Validator_OrderConfigAvailability_Partial_Data),
        mon: tsValidateArray(Validator_OrderConfigAvailability_Partial_Data),
        tue: tsValidateArray(Validator_OrderConfigAvailability_Partial_Data),
        wed: tsValidateArray(Validator_OrderConfigAvailability_Partial_Data),
        thu: tsValidateArray(Validator_OrderConfigAvailability_Partial_Data),
        fri: tsValidateArray(Validator_OrderConfigAvailability_Partial_Data),
        sat: tsValidateArray(Validator_OrderConfigAvailability_Partial_Data),
    }
};
const Validator_OrderConfigAvailability = (instance) => {
    if (instance?.type === OrderAvailability_Always)
        return tsValidateResult(instance, Validator_OrderConfigAvailability_Always);
    if (instance?.type === OrderAvailability_Partial)
        return tsValidateResult(instance, Validator_OrderConfigAvailability_Partial);
    // @ts-ignore
    throw new MUSTNeverHappenException(`Unknown availability type ${instance?.type}`);
};
const Validator_ModifiableProps = {
    ehrInstallationId: tsValidateUniqueId,
    orderId: tsValidateUniqueId,
    ehrInstallationOrderId: tsValidateString(-1, false),
    availability: Validator_OrderConfigAvailability
};
export const DBDef_OrderConfiguration = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'order-configuration',
    entityName: 'OrderConfiguration',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'order-configuration'
    },
    backend: {
        name: 'order-configuration'
    },
    dependencies: {
        orderId: {
            dbKey: 'orders',
            fieldType: 'string'
        },
        ehrInstallationId: {
            dbKey: DBDef_EHRInstallation.dbKey,
            fieldType: 'string'
        }
    }
};
//# sourceMappingURL=db-def.js.map